/* eslint-disable  */
import DefaultLayout from '##/Default';
import List from './List';
import DeptEmployees from './DeptEmployees'


const routes = [
    {
        path: '/departments',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'View Departments'
    },

    {
        path: '/departments/:department_id/employees',
        exact: true,
        layout: DefaultLayout,
        component: DeptEmployees,
        auth: true,
        title: 'deptEmployees'
    }
];

export default routes;
